import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Crest } from "@/components/Crest";
import { ArrowRight, Youtube, Instagram, Facebook, Linkedin, Twitter, Music2 } from "lucide-react";

const SOCIAL_ICON = { youtube: Youtube, instagram: Instagram, facebook: Facebook, linkedin: Linkedin, x: Twitter, tiktok: Music2 };

export default function Connect() {
  const { lang } = useI18n();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const ref = sp.get("ref") || sp.get("utm_source") || "direct";
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/connect").then((r) => setData(r.data)).catch(() => setData({ ctas: [], socials: [] }));
    api.post("/connect/track", { ref, event: "view" }).catch(() => {});
  }, [ref]);

  const go = (item) => {
    api.post("/connect/track", { ref, cta: item.key || item.label_en, event: "click" }).catch(() => {});
    const url = item.url || "#";
    if (url.startsWith("http")) window.location.href = url;
    else nav(url);
  };
  const L = (o) => (lang === "fr" ? (o.label_fr || o.label_en) : o.label_en);

  return (
    <div className="min-h-screen bg-ink text-paper" data-testid="connect-page">
      <div className="max-w-md mx-auto px-5 py-12">
        <div className="flex flex-col items-center text-center">
          <Crest className="h-16 w-16" />
          <div className="mt-4 font-serif text-2xl tracking-tight">Simo University</div>
          <div className="mt-1 text-paper/50 text-sm">{lang === "fr" ? "De la maternelle au doctorat · en ligne, partout dans le monde" : "From Pre-K to PhD · online, worldwide"}</div>
          <div className="mt-3 h-px w-16 bg-heraldic" />
        </div>

        {!data ? (
          <div className="mt-10 text-center text-paper/40">…</div>
        ) : (
          <>
            <div className="mt-9 space-y-3">
              {data.ctas.map((c) => (
                <button key={c.cid} data-testid={`connect-cta-${c.key}`} onClick={() => go(c)}
                  className="w-full flex items-center justify-between gap-3 bg-white/5 hover:bg-heraldic hover:border-heraldic border border-white/10 rounded-lg px-5 py-4 transition-colors">
                  <span className="font-medium text-left">{L(c)}</span>
                  <ArrowRight className="h-4 w-4 opacity-70 shrink-0" />
                </button>
              ))}
            </div>

            {data.socials.length > 0 && (
              <div className="mt-8 flex flex-wrap justify-center gap-3">
                {data.socials.map((s) => {
                  const Ic = SOCIAL_ICON[s.icon] || ArrowRight;
                  return (
                    <button key={s.cid} data-testid={`connect-social-${s.key}`} onClick={() => go(s)} aria-label={s.label_en}
                      className="h-11 w-11 rounded-full bg-white/5 hover:bg-white/15 border border-white/10 flex items-center justify-center transition-colors">
                      <Ic className="h-5 w-5" />
                    </button>
                  );
                })}
              </div>
            )}
          </>
        )}
        <div className="mt-12 text-center text-xs text-paper/30">© Simo University · {lang === "fr" ? "Institution mondiale fondée sur la maîtrise" : "A mastery-based global institution"}</div>
      </div>
    </div>
  );
}
